import type { BackendPaginationMeta } from 'src/components/ServerPaginatedTable/types';
import { DEFAULT_PAGINATION_META } from 'src/components/ServerPaginatedTable/constants';
import {
  LearningResourceCategory,
  LearningResourceRecord,
  LearningResourceSortField,
} from '../services/learning-resources/types';

export interface LearningResourcesState {
  items: LearningResourceRecord[];
  loading: boolean;
  saving: boolean;
  hasLoaded: boolean;
  error: string | null;
  categoryFilter: LearningResourceCategory | 'all';
  pagination: BackendPaginationMeta;
  sortBy: LearningResourceSortField;
  sortDirection: 'asc' | 'desc';
}

export const initialState: LearningResourcesState = {
  items: [],
  loading: false,
  saving: false,
  hasLoaded: false,
  error: null,
  categoryFilter: 'all',
  pagination: DEFAULT_PAGINATION_META,
  sortBy: 'order',
  sortDirection: 'asc',
};
